module.exports = __webpack_public_path__ + "static/retail_mobile-926f3febc1a292a00e0bd790a09c7548.jpg";